/**
 * Deposit Button Replacer View
 */

define(function(require, exports, module) {
    'use strict';

    var DepositButtonReplacer = require('replacers/deposit-button/deposit-button.view.js');
    var quickDepositService = require('modules/cashier/quick-deposit/quick-deposit.service.instance');
    var config = require('config');

    module.exports = DepositButtonReplacer.extend({

        render: function() {
            var name = this.options.name;
            var quickDeposit = quickDepositService.isQuickDepositAvailable() && config.get('quickDepositPage');
            var deposit = config.get('depositPage');
            var depositLink = quickDeposit || deposit;

            if (depositLink) {
                const isHeaderButton = ['headerdepositbutton', 'HEADER_DEPOSIT_BUTTON'].includes(name);
                const isContentButton = ['contentdepositbutton', 'CONTENT_DEPOSIT_BUTTON'].includes(name);

                const className = [
                    'btn btn_action_deposit fn-redirect common-deposit', /* TotalCasino changes */
                    isHeaderButton && 'btn_size_small',
                    isContentButton && 'btn_deposit_balance',
                    quickDeposit && 'fn-quick-deposit'
                ].filter(Boolean).join(' ');

                this.$el.html(this.tmpl('deposit-button', {
                    className: className,
                    depositLink: depositLink,
                    depositLinkText: `playtech.mobile.system.${quickDeposit ? 'quick-deposit' : 'deposit'}`,
                }));
            }

            return this;
        }

    });
});
